// extracted by mini-css-extract-plugin
export default {"video_player":"Session_video_player__MKEb1","content":"Session_content__LBQQ7"};